'use client';

import { Suspense } from 'react';
import { Box } from '@mui/material';

import {
  BackToTopButton,
  ComponentErrorBoundary,
  SportsSidebar,
  SportsSidebarSkeleton,
} from '@/components';

interface SportsLayoutProps {
  children: React.ReactNode;
}

/**
 * SportsLayout provides the common structural shell for all sports-related pages.
 * It includes the SportsSidebar on the left and a flexible content area for pages.
 */
export const SportsLayoutComponent = ({ children }: SportsLayoutProps) => {
  return (
    <ComponentErrorBoundary componentName="SportsLayout">
      <Box sx={{ py: { xs: 1, sm: 2 } }}>
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 0, lg: 2 },
            alignItems: 'flex-start',
            flexDirection: { xs: 'column', lg: 'row' },
            height: { lg: 'calc(100vh - 100px)' },
            overflow: { lg: 'hidden' },
          }}
        >
          {/* Main Sports Sidebar - Sticky on desktop */}
          <Box
            sx={{
              width: { xs: '100%', lg: 240 },
              flexShrink: 0,
              position: { lg: 'sticky' },
              top: 0,
              alignSelf: 'flex-start',
            }}
          >
            <Suspense fallback={<SportsSidebarSkeleton />}>
              <SportsSidebar />
            </Suspense>
          </Box>

          {/* Children will render the Main Content Area and optional Trading Sidebar */}
          {children}
        </Box>
        <BackToTopButton />
      </Box>
    </ComponentErrorBoundary>
  );
};

export default SportsLayoutComponent;
